import React from 'react';

import { SiteFooter } from '../../components/SiteFooter/SiteFooter';
import { SiteNav } from '../../components/SiteNav/SiteNav';
import { AthletesSection } from './AthletesSection';
import { CtaBlockSection } from './CtaBlockSection';
import { HeroSection } from './HeroSection';
import { HowItWorksSection } from './HowItWorksSection';
import type { Athletes, CtaBlock, Hero, HowItWorks } from './slides';

type ForBrandProps = {
    csrfToken: string;
    hero: Hero;
    athletes: Athletes;
    howItWorks: HowItWorks;
    ctaBlock: CtaBlock;
};

export function ForBrand({ csrfToken, hero, athletes, howItWorks, ctaBlock }: ForBrandProps) {
    return (
        <div className="for-brand">
            <HeroSection data={hero} nav={<SiteNav />} />
            <AthletesSection data={athletes} />
            <HowItWorksSection data={howItWorks} />
            <CtaBlockSection data={ctaBlock} />
            <SiteFooter csrfToken={csrfToken} />
        </div>
    );
}
